import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik } from 'formik';
import { tankUpdateValidationSchema } from '../../validation/tank';
import TankForm from '~/components/tankForm/tankForm';
import Spinner from '~/components/spinner/spinner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getTankQuery = gql`
  query tank($id: Int!) {
    tank(id: $id) {
      id
      name
      notes
      type
      volume
      status
      currentLot {
        id
        reference
      }
    }
  }
`;

export const updateTanksMutation = gql`
  mutation updateTank(
    $id: Int!
    $name: String!
    $notes: String
    $status: TankStatus!
    $type: TankType!
    $volume: Int!
  ) {
    updateTank(id: $id, name: $name, notes: $notes, status: $status, type: $type, volume: $volume) {
      id
      name
      notes
      type
      status
      volume
    }
  }
`;

const TankEdit = ({ onCompleted, id, history }) => (
  <Query query={getTankQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      const { tank } = data;
      return (
        <div className="content">
          <Mutation mutation={updateTanksMutation}>
            {(updateTank, { error }) => (
              <Formik
                initialValues={tank}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={tankUpdateValidationSchema}
                onSubmit={async (values, { setErrors, setSubmitting }) => {
                  try {
                    await updateTank({
                      variables: {
                        id,
                        ...values
                      }
                    });
                    history.push(`/tanks/${id}?updated=true`);
                  } catch (err) {
                    setErrors({
                      unknown: 'An unknown error occured'
                    });
                    setSubmitting(false);
                  }
                }}
                render={TankForm}
              />
            )}
          </Mutation>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(TankEdit));



// WEBPACK FOOTER //
// ./src/containers/tankEdit/tankEdit.jsx